import { synthscape as synthscapeBase } from "@thirdparty/companies";

import { fizz } from "../fizz";
import { GtbCustomApp } from "../gtb/types";

export const synthscape: GtbCustomApp = {
  ...synthscapeBase,
  routes: fizz.routes,
};
